export default function StripeConfirm() {
  window.top.postMessage("3DS-authentication-complete");
  return null;
}
